import { createContext } from 'react';

const RenderContext = /*#__PURE__*/createContext(null);

export { RenderContext };
